export class Modulo {
	id:number;
	descricao:string;
	nome:string;
	moduloPai: Modulo
}
	